import GeoclaimPage from './Page'

export default GeoclaimPage
